import { CircularProgress } from '@mui/material';
import React from 'react';

interface MediaPreviewProps {
  url: string;
  isVideo: boolean;
  showPreview: boolean;
  onLoad: () => void;
  onVideoLoadedData?: (duration: number) => void;
  apiHost?: string;
}

// This component handles both image and video preview with duration tracking
export default function MediaPreview({
  url,
  isVideo,
  showPreview,
  onLoad,
  onVideoLoadedData,
  apiHost
}: MediaPreviewProps) {
  // Transform video URL if needed
  const videoUrl = isVideo && apiHost 
    ? `${apiHost}/admin/helpers/s3_get_resource/${encodeURIComponent(url)}`
    : url;

  return (
    <>
      {!isVideo ? (
        <img
          src={url}
          alt="Preview"
          style={{
            display: showPreview ? 'block' : 'none',
            maxHeight: '300px',
            maxWidth: '100%',
            objectFit: 'contain'
          }}
          onLoad={onLoad}
        />
      ) : (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          controls
          preload="metadata"
          style={{
            display: showPreview ? 'block' : 'none',
            maxHeight: '300px',
            maxWidth: '100%'
          }}
          onLoadedData={(e) => {
            onLoad();
            if (onVideoLoadedData) {
              onVideoLoadedData(e.currentTarget.duration);
            }
          }}
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      )}
      {!showPreview && <CircularProgress size={24} />}
    </>
  );
}